import { MosaicTile, RawVisionFrame } from '../architecture/mosaic_pipeline';

export class HighlanderMutexTile implements MosaicTile<RawVisionFrame, RawVisionFrame> {
  public readonly tileId = 'HighlanderMutexTile';

  public process(frame: RawVisionFrame): RawVisionFrame | null {
    // Stub implementation: return the frame untouched
    return frame;
  }
}
